export default () => ({
  filterWrapper: {
    display: 'flex',
    flexWrap: 'wrap',
    width: '100%',
  },
  datePickerStartEnd: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
  actionExport: {
    display: 'flex',
    flexDirection: 'column',
    marginLeft: '0.8rem',
    marginRight: '0.8rem',
    justifyContent: 'center',
  },
  buttonExport: {
    paddingTop: '0.5rem',
    paddingBottom: '0.5rem',
  },
})
